// src/pages/admin/AutomationsPage.js
import React from "react";

const AutomationsPage = () => {
  return (
    <main className="flex-1 p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">Automations</h1>
      <p className="text-gray-600 mb-6">
        Manage automated workflows triggered by user actions or system events.
      </p>

      <div className="bg-white p-6 rounded-xl shadow">
        <ul className="text-sm text-gray-700 space-y-2 list-disc list-inside">
          <li>Email confirmation after form submission</li>
          <li>Reminders for uncompleted bookings</li>
          <li>Webhook triggers for third-party services</li>
          <li>Scheduled tasks (daily reports, data sync)</li>
        </ul>
      </div>
    </main>
  );
};

export default AutomationsPage;
